import classNames from "classnames";
import { AssetCard } from "features/Application/components/Card/Assets/AssetCard/AssetCard";
import { CardSessionStatus } from "features/Application/components/Card/CardSessionStatus/CardSessionStatus";
import { RStatus } from "features/Application/types";
import { queryStringService } from "features/Application/utils/queryStringService";
import { Carousel } from "features/Home/components/Carousel/Carousel";
import { req, reset } from "features/Home/redux/homePageContent/homeUpcomingEventsSlice";
import { selectUpcomingEventsState } from "features/Home/redux/homePageContent/selectors";
import { type UpcomingEvent } from "features/Home/types";
import { Routes } from "features/common/routes";
import { EntityType } from "features/common/types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styles from "./UpcomingEvents.module.scss";

const cx = classNames.bind(styles);

const emptyEvents = Array(5).fill({} as UpcomingEvent);

const eventsFilter: any = { appliedFilters: { entityType: [EntityType.Event] } };

export const UpcomingEvents: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["application"]);
  const eventsState = useSelector(selectUpcomingEventsState);
  const events: UpcomingEvent[] = eventsState.status === RStatus.Got ? eventsState.items : emptyEvents;

  useEffect(() => {
    dispatch(req());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  if (eventsState.status === RStatus.Error || (eventsState.status === RStatus.Got && eventsState.items.length === 0)) {
    return null;
  }
  return (
    <div className={cx(styles.root)}>
      <Carousel
        items={events}
        title={t("carousel.upcomingEventSessions")}
        renderCard={item => {
          return (
            <AssetCard
              loading={eventsState.status === RStatus.Pending}
              item={item}
              to={`${Routes.Discover.event}/${item.id}`}
              extraMeta={<CardSessionStatus entityType={item.entityType} status={item.isRegistered ? 1 : 0} />}
              metaClassName="keepMetaInline"
            />
          );
        }}
      />
      <div className={cx(styles.viewAll)}>
        <Link
          to={`${Routes.Discover.exact}?${queryStringService.stringify(eventsFilter)}`}
          aria-label={t("common.viewAllAssetType", {
            item: "Upcoming Event Sessions",
          })}
        >
          {t("common.viewAll")}
        </Link>
      </div>
    </div>
  );
};
